// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.async.PollConfiguration
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class PollConfigurationBase {
  /** Do NOT invoke directly, instead use strongly typed createPollConfigurationBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawada.PollConfiguration";
  }
  initFromJson(json, deserializeContext) {
    this.initPollConfiguration(json.idleTimeout, json.isWSDisabled, json.sessionTimeout);
  }
  initPollConfiguration(idleTimeout, isWSDisabled, sessionTimeout) {
    this._idleTimeout = idleTimeout;
    this._isWSDisabled = isWSDisabled;
    this._sessionTimeout = sessionTimeout;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["idleTimeout"] = this._idleTimeout;
    retVal["isWSDisabled"] = this._isWSDisabled;
    retVal["sessionTimeout"] = this._sessionTimeout;
    return retVal;
  }
  get idleTimeout() {
    return this._idleTimeout;
  }
  set idleTimeout(value) {
    this._idleTimeout = value;
  }
  get isWSDisabled() {
    return this._isWSDisabled;
  }
  set isWSDisabled(value) {
    this._isWSDisabled = value;
  }
  get sessionTimeout() {
    return this._sessionTimeout;
  }
  set sessionTimeout(value) {
    this._sessionTimeout = value;
  }
}
//# sourceMappingURL=PollConfigurationBase.js.map
